
import customSelectInit from "../components/custom-select.js";
import filtersInit from "@/frontend/js/components/filters.js";

document.addEventListener("DOMContentLoaded", () => {

    customSelectInit();

    const  { filterSidebarInit } = filtersInit();
    filterSidebarInit();

    const InteriorCardElements = document.querySelectorAll('.interior__list_item');

    InteriorCardElements.forEach((card) => {
        card.addEventListener('click', () => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 1200) {
                //if target not a link, toggle active class
                if (!event.target.closest('.article__item_info')) {
                    card.classList.toggle('active');
                }
            }
        });
    });

});
